<script setup>
import {useMainOrdersStore} from '@/stores/mainOrders.js'
import {useConfigStore} from '@/stores/config.js'
import {computed} from "vue";
import Badge from "@/components/Badge/index.vue";
import Card from "@/components/Card/index.vue";
import Button from "@/components/Button/index.vue";
import GamesSkeleton from "@/components/Skeleton/Games.vue";
import {useRouter, useRoute} from "vue-router";

/* ---------- vue-router ---------- */
const router = useRouter();
const route = useRoute();

/* ---------- Stores ---------- */
const ordersStore = useMainOrdersStore()
const configStore = useConfigStore()
const games = computed(() => configStore.getGamesByService('StocksManager') || [])

function onGameClick(myGame) {
  router.push({name: 'stocks-servers', params: {game: myGame.abbreviation}})
}
</script>

<template>
  <div>
    <div>
      <div v-if="games" class="grid xl:grid-cols-6 md:grid-cols-4 sm:grid-cols-3 grid-cols-1 gap-4">
        <div v-for="(game, index) in games" class="aspect-[16/9] rounded-2xl relative overflow-hidden cursor-pointer"
             @click="onGameClick(game)">
          <img :src="game.banner" alt="" class="w-full h-full">
          <button
              class="absolute bottom-0 p-2 flex justify-center items-center w-full bg-black-500/60 text-white text-xs">
            {{ game.game }}
          </button>
        </div>
      </div>
      <GamesSkeleton v-else></GamesSkeleton>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>